import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Heart } from "lucide-react";
import { api } from "../lib/api";
import { Reveal, Floral, GoldDivider } from "../components/Decor";
import { HISTORY } from "../constants/site";

export default function NossaHistoria() {
  const [photos, setPhotos] = useState([]);
  const frameRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: frameRef, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-24, 24]);

  useEffect(() => {
    api
      .get("/gallery")
      .then(({ data }) => setPhotos(data.photos || []))
      .catch(() => {});
  }, []);

  return (
    <div className="relative overflow-hidden pt-28" data-testid="page-historia">
      <Floral variant="top" className="absolute -left-20 -top-4 w-72 opacity-80" />
      <header className="relative mx-auto max-w-3xl px-5 text-center">
        <p className="eyebrow">13 . 02 . 2021 — para sempre</p>
        <h1 className="mt-4 font-script text-6xl text-ink sm:text-7xl">{HISTORY.title}</h1>
        <GoldDivider className="mt-8" />
      </header>

      <section className="relative mx-auto max-w-3xl px-5 pb-4">
        {HISTORY.paragraphs.map((p, i) => (
          <Reveal key={i} delay={0.04 * i}>
            <p className={`mt-8 font-serif text-xl leading-relaxed text-ink/85 first-letter:text-ink ${i === 0 ? "text-2xl" : ""}`}>
              {p}
            </p>
          </Reveal>
        ))}
      </section>

      <section ref={frameRef} className="relative mx-auto max-w-4xl px-5 py-16">
        <motion.div style={{ y }} className="relative mx-auto max-w-md">
          <Reveal>
            <div className="gold-frame bg-white p-3 shadow-soft" data-testid="historia-photo">
              <img src="/images/avatar-casal.jpeg" alt="Rodrigo e Talita" className="aspect-[4/5] w-full object-cover" />
            </div>
          </Reveal>
          <Floral variant="side" className="absolute -right-16 -top-14 w-32 opacity-90" />
        </motion.div>
      </section>

      {photos.length > 0 && (
        <section className="mx-auto max-w-6xl px-5 pb-8" data-testid="historia-galeria">
          <h2 className="text-center font-serif text-3xl uppercase tracking-[0.14em] text-ink">Nossas memórias</h2>
          <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-4">
            {photos.map((p, i) => (
              <Reveal key={p.id} delay={0.05 * i}>
                <img
                  src={`${process.env.REACT_APP_BACKEND_URL}${p.url}`}
                  alt={p.original_filename || "Memória do casal"}
                  loading="lazy"
                  className="aspect-square w-full border border-gold-border bg-white object-cover p-2"
                />
              </Reveal>
            ))}
          </div>
        </section>
      )}

      <section className="mx-auto max-w-2xl px-5 pb-24 pt-8 text-center">
        <Reveal>
          <GoldDivider className="mb-8" />
          <p className="font-serif text-2xl italic text-ink/80">
            O melhor da nossa história não é apenas tudo o que vivemos até aqui, mas principalmente tudo o que ainda vamos viver juntos.
          </p>
          <Link to="/confirmacao-presenca" data-testid="historia-cta-rsvp" className="btn-gold mt-8">
            <Heart size={14} /> Confirme sua presença
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
